import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";

import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { BRAND } from "@/config/brand";

/**
 * White-label microsite shell: NO platform header — organizer branding
 * dominates. Only a tiny "Powered by …" footer line references the platform.
 */
export const MicrositeLayout = () => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col bg-white microsite-shell">
      <motion.main
        key={location.pathname}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
        className="flex-1"
      >
        <Outlet />
      </motion.main>
      <footer data-testid="microsite-footer" className="microsite-mini-footer border-t border-black/5 py-6 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-12 flex items-center justify-center gap-4 text-xs text-[#737373]">
          <span data-testid="microsite-powered-by">{t("footer.poweredBy", { name: BRAND.poweredBy })}</span>
          <span className="w-px h-4 bg-black/10" aria-hidden="true" />
          <LanguageSwitcher />
        </div>
      </footer>
    </div>
  );
};
